// @flow

import React from "react";

import { isNil } from "ramda";

import {
  type State,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";
import {
  type MedidaSelecionada,
  ID_OPCAO_DEFLATOR_NENHUM,
} from "../../../model";

import SelecaoDeflacao from "../configuracoes/deflacao/SelecaoDeflacao";

export const processarSeriesComDeflator = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const edicaoMedida = getEdicaoMedida(state);
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

  return medidas.map(medida => {
    if (
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.deflator) &&
      edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
    ) {
      return {
        ...medida,
        deflator: edicaoMedida.deflator,
        valorBaseDeflator: edicaoMedida.valorBaseDeflator,
        valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
        dataBaseDeflator: edicaoMedida.dataBaseDeflator,
        dataBaseDeflatorDataEspecifica:
          edicaoMedida.dataBaseDeflatorDataEspecifica,
        ...analiseValorDaMedida(medida, state),
      };
    } else {
      return {
        ...medida,
        ...analiseValorDaMedida(medida, state),
      };
    }
  });
};

const SeriesComDeflator = () => {
  return (
    <>
      <SelecaoDeflacao />
    </>
  );
};

export default SeriesComDeflator;
